import { createContext } from "react";

import { inferRouterInputs, inferRouterOutputs } from "@trpc/server";

import { AppRouterType } from "../helpers/trpc";

type OrganizationEngagementFlagsObject = NonNullable<
  inferRouterOutputs<AppRouterType>["getOrganizationEngagementFlags"]
>;

export type OrganizationEngagementFlags = Omit<OrganizationEngagementFlagsObject, "id">;

export type UpdateEngagementFlagsInput = Omit<
  inferRouterInputs<AppRouterType>["updateOrganizationEngagementFlags"],
  "id"
>;

interface OrganizationEngagementFlagsContextProps {
  flags: OrganizationEngagementFlags | undefined;
  loading: boolean;
  updateFlags: (flags: UpdateEngagementFlagsInput) => void;
}

export const OrganizationEngagementFlagsContext = createContext<OrganizationEngagementFlagsContextProps>({
  flags: undefined,
  loading: false,
  updateFlags: () => {},
});
